import { localStore } from '~/modules/common/utils/localStorageUtils';

/**
 * Checks wheter or not article read
 *
 * @param {object} article - article object
 */
export function getReadStatus(article) {
  const status = localStore.getItem('stn-articles', 'v1') || {};
  return status[article._id];
}

/**
 * Sets article read
 *
 * @param {object} article - article object
 */
export function setReadStatus(article) {
  const readStatusStore = localStore.getItem('stn-articles', 'v1') || {};
  readStatusStore[article._id] = true;
  localStore.setItem('stn-articles', readStatusStore, { expireMs: 60 * 60 * 24 * 7, version: 'v1' });
}

function ease(k) {
  return 0.5 * (1 - Math.cos(Math.PI * k));
}
function step(context) {
  const now = window.performance && window.performance.now ? window.performance.now.bind(window.performance) : Date.now;
  const time = now();
  let elapsed = (time - context.startTime) / 2000;
  const y = context.el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - (context.topOffset ? context.topOffset : 60);

  if (y !== context.y) context.y = y;

  // avoid elapsed times higher than one
  elapsed = elapsed > 1 ? 1 : elapsed;

  // apply easing to elapsed time
  const value = ease(elapsed);

  //   const currentX = context.startX + (context.x - context.startX) * value;
  const currentY = context.startY + (context.y - context.startY) * value;

  context.method.call(context.scrollable, 0, currentY);

  // scroll more if we have not reached our destination
  if (currentY !== context.y) {
    window.requestAnimationFrame(step.bind(window, context));
  } else if (context.callback) {
    context.callback();
  }
}
export function smoothScrollY(el, callback, topOffset) {
  const now = window.performance && window.performance.now ? window.performance.now.bind(window.performance) : Date.now;
  const scrollable = window;
  const startY = window.scrollY || window.pageYOffset;
  const method = window.scroll || window.scrollTo;
  const startTime = now();

  // scroll looping over a frame
  step({
    scrollable,
    method,
    startTime,
    startY,
    el,
    callback,
    topOffset,
  });
}
